import { RoutesEnum } from '~/enums/'
import { META_CONTENTS } from '~/resources/meta-content'

export const useMeta = () => {
  const { BRAND_NAME } = useRuntimeConfig().public
  const route = useRoute()

  const currentMeta = computed(() => {
    return (
      META_CONTENTS(BRAND_NAME).find((meta) => {
        if (route.fullPath.includes(RoutesEnum.LiveCasino)) {
          if (meta.category.includes(RoutesEnum.LiveCasino.replace('/', ''))) {
            return route.fullPath.includes(meta.seo_url)
          }
          return meta.seo_url === route.fullPath
        }
        if (route.fullPath.includes(RoutesEnum.LobbyGame)) {
          if (meta.category.includes(RoutesEnum.LobbyGame.replace('/', ''))) {
            return route.fullPath.includes(meta.seo_url)
          }
          return meta.seo_url === route.fullPath
        }
        if (meta.seo_url != RoutesEnum.Home) {
          return route.fullPath.includes(meta.seo_url)
        }
        return false
      }) || META_CONTENTS(BRAND_NAME)[0]
    )
  })

  return {
    currentMeta,
  }
}
